var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 30H16.5C16.5 31.65 15.15 33 13.5 33C11.85 33 10.5 31.65 10.5 30ZM7.5 28.5H19.5V25.5H7.5V28.5ZM24.75 14.25C24.75 19.98 20.76 23.04 19.095 24H7.905C6.24 23.04 2.25 19.98 2.25 14.25C2.25 8.04 7.29 3 13.5 3C19.71 3 24.75 8.04 24.75 14.25ZM21.75 14.25C21.75 9.705 18.045 6 13.5 6C8.955 6 5.25 9.705 5.25 14.25C5.25 17.955 7.485 20.085 8.775 21H18.225C19.515 20.085 21.75 17.955 21.75 14.25ZM32.055 11.055L30 12L32.055 12.945L33 15L33.945 12.945L36 12L33.945 11.055L33 9L32.055 11.055ZM28.5 9L29.91 5.91L33 4.5L29.91 3.09L28.5 0L27.09 3.09L24 4.5L27.09 5.91L28.5 9Z",
    fill: "#FCD300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsIcon);
export default __webpack_public_path__ + "static/media/tips-icon.6d24fa9ad51ba2624665db75809dbbb2.svg";
export { ForwardRef as ReactComponent };